import { render } from "./financial-details.vue?vue&type=template&id=361393e8&scoped=true"
import script from "./financial-details.vue?vue&type=script&lang=js"
export * from "./financial-details.vue?vue&type=script&lang=js"

import "./financial-details.vue?vue&type=style&index=0&id=361393e8&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361393e8"]])

export default __exports__